<template>
    <div>
        <tab name="1" :activity-name="activityName"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.tags" placeholder="请输入照片标签" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType1" slot="prepend" placeholder="请选择">
                                <el-option label="上传时间" :value="1"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker v-model="datetimerange1" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" class="fl" size="small" value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']" align="right" unlink-panels>
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType2" slot="prepend" placeholder="请选择">
                                <el-option label="拍摄时间" :value="1"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker v-model="datetimerange2" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" class="fl" size="small" value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']" align="right" unlink-panels>
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/photo/confirmUpload')" type="primary" size="small"
                @click="$router.push(`/dynamic/photo/add?activityId=${id}`)">上传照片</el-button>
            <el-button v-if="$utils.have('/photo/setTags')" type="primary" size="small" @click="setTags()">批量打标签
            </el-button>
            <el-button v-if="$utils.have('/photo/delete')" type="primary" size="small" @click="del()">批量删除照片</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe
                @selection-change="handleSelectionChange">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="url" label="照片">
                    <template slot-scope="{row} = scope">
                        <el-image :src="row.url | coverImage(160,160)" fit="cover" :preview-src-list="[row.url]"
                            style="width:80px;height:80px;"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="tags" label="照片标签" show-overflow-tooltip></el-table-column>
                <el-table-column prop="title" label="演出名称" show-overflow-tooltip min-width="150"></el-table-column>
                <el-table-column prop="shootingTime" label="拍摄时间" min-width="150"></el-table-column>
                <el-table-column prop="createTime" label="上传时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="{row} = scope">
                        <el-button v-if="$utils.have('/photo/delete')" type="text" size="small" @click="del(row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <set-tags ref="setTags" :activity-name="activityName" :tags-list="tagsList" @onUpdate="getDataList"></set-tags>
    </div>
</template>

<script>
import Tab from '../components/tab.vue'
import SetTags from './components/SetTags.vue'
const defaultParams = {
    pageNo: 1,
    activityId: "",
    createTimeEnd: "",
    createTimeStart: "",
    timeType1: 1,
    shootingTimeEnd: "",
    shootingTimeStart: "",
    timeType2: 1,
    tags: "",
}
export default {
    props: {
        id: {
            type: [String, Number],
            default: ""
        }
    },
    components: { Tab, SetTags },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                timeType1: parseInt(this.$route.query.timeType1 || 1),
                timeType2: parseInt(this.$route.query.timeType2 || 1),
                tags: this.$route.query.tags || "",
            },
            listLoading: true,
            datetimerange1: [this.$route.query.createTimeStart || '', this.$route.query.createTimeEnd || ''],
            datetimerange2: [this.$route.query.shootingTimeStart || '', this.$route.query.shootingTimeEnd || ''],
            photoIds: [],
            activityName: this.$route.query.activityName || "",
            tagsList: []
        }
    },
    mounted() {
        this.getDataList();
        this.getTags();
    },
    methods: {
        //获取列表
        getDataList() {
            this.params = {
                ...this.params,
                activityId: this.id,
                createTimeStart: this.datetimerange1 && this.datetimerange1[0] || '',
                createTimeEnd: this.datetimerange1 && this.datetimerange1[1] || '',
                shootingTimeStart: this.datetimerange2 && this.datetimerange2[0] || '',
                shootingTimeEnd: this.datetimerange2 && this.datetimerange2[1] || '',
            }
            this.listLoading = true;
            this.$request({
                url: "/photo/allPhoto",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];

                        if(!this.activityName && this.dataList.length > 0){
                            this.activityName = this.dataList[0].title;
                        }
                    } else {
                        this.data = null;
                        this.dataList = [];
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange1 = [];
            this.datetimerange2 = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //全选、反选
        handleSelectionChange(val) {
            this.photoIds = val.map(v => v.id);
        },
        //删除照片
        del(id) {
            let _msg = "";
            let _photoIds = "";
            if (id) {
                _msg = "确定要删除这张照片吗？删除后不可恢复";
                _photoIds = id;
            } else {
                if (this.photoIds.length < 1) {
                    return this.$message.error("请选择要删除的照片");
                } else {
                    _msg = "确定要删除吗？删除后不可恢复";
                    _photoIds = this.photoIds.toString();
                }
            }
            this.$confirm(_msg, '删除', {
                center: true,
            }).then(() => {
                this.$request({
                    url: "/photo/delete",
                    method: "POST",
                    params: {
                        photoIds: _photoIds
                    },
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.search();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
            }).catch(() => {

            })
        },
        //获取标签列表
        getTags() {
            this.$request({
                url: "/photo/getTags",
                method: "POST",
                params: {
                    activityId: this.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.tagsList = result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
        },
        //批量打标签
        setTags() {
            if (this.photoIds.length < 1) {
                return this.$message.error("请选择要打标签的照片");
            }
            this.$refs.setTags.show(this.photoIds)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>